import { apiClient } from './api'
import type { AnchorUserChatSummary } from '@/types'

export const userSummaryApi = {
  getChatSummary(userId: string) {
    return apiClient.get<AnchorUserChatSummary>(`/video-users/${userId}/chat-summary`)
  },
}
